import React, { useState, useEffect, useRef } from 'react';
import Header from '../components/header';
import DefaultFooter from '../components/default-footer';

// ============================================================
// EducationalTrips.tsx
//
// Premium single service page for Educational Trips.
// Features: SVG icons, real educational imagery, rich content.
// ============================================================

function DuneRule() {
  return (
    <div aria-hidden="true" style={{ lineHeight: 0 }}>
      <svg viewBox="0 0 1200 34" width="100%" height="22" preserveAspectRatio="none">
        <path d="M0 24 C 90 4, 170 4, 250 20 S 400 30, 480 14 S 620 2, 700 18 S 850 30, 940 12 S 1090 2, 1200 16" fill="none" stroke="var(--gold-d)" strokeOpacity="0.55" strokeWidth="1.5" />
        <path d="M0 28 C 90 12, 170 12, 250 26 S 400 34, 480 20 S 620 10, 700 24 S 850 34, 940 18 S 1090 10, 1200 22" fill="none" stroke="rgba(41,75,90,.14)" strokeWidth="1" />
      </svg>
    </div>
  );
}

// ============================================================
// ICÔNES SVG ÉLÉGANTES
// ============================================================

function IconBrain() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--gold-d)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 4a4 4 0 0 1 4 4c0 1.5-.5 2.5-1.5 3.5" />
      <path d="M12 4a4 4 0 0 0-4 4c0 1.5.5 2.5 1.5 3.5" />
      <path d="M8 15c0-1.5 1-2.5 2-3" />
      <path d="M16 15c0-1.5-1-2.5-2-3" />
      <path d="M12 4v14" />
      <path d="M6 19h12" />
      <circle cx="12" cy="18" r="1.5" />
    </svg>
  );
}

function IconGlobe() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--gold-d)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3c2.5 2.5 2.5 15.5 0 18" />
      <path d="M12 3c-2.5 2.5-2.5 15.5 0 18" />
    </svg>
  );
}

function IconUsers() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--gold-d)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

function IconStar() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--gold-d)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 3 14.7 9.3 21.2 9.3 16.3 13.5 18.5 19.7 12 16.5 5.5 19.7 7.7 13.5 2.8 9.3 9.3 9.3 12 3" />
    </svg>
  );
}

function IconMap() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--gold-d)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 20l-5-2V6l5 2 6-2 5 2v12l-5-2-6 2z" />
      <path d="M9 6v14" />
      <path d="M15 4v14" />
    </svg>
  );
}

function IconBook() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--gold-d)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      <path d="M12 9l-2.5 4.5 2.5 3 2.5-3-2.5-4.5z" />
    </svg>
  );
}

function IconShield() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--gold-d)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}

function IconClock() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--gold-d)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.2 3.2" />
    </svg>
  );
}

// ============================================================
// PHOTOS ADAPTÉES POUR L'ÉDUCATION
// ============================================================

const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1523050854058-8df90110c7f1?w=1800&q=80&fit=crop&crop=center',
  students: 'https://images.unsplash.com/photo-1523050854058-8df90110c7f1?w=1200&q=80&fit=crop&crop=center',
  classroom: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1200&q=80&fit=crop&crop=center',
  museum: 'https://images.unsplash.com/photo-1531995811006-35cb42e1a022?w=1200&q=80&fit=crop&crop=center',
  science: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=1200&q=80&fit=crop&crop=center',
  nature: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80&fit=crop&crop=center',
  history: 'https://images.unsplash.com/photo-1558636508-e0db3814bd1d?w=1200&q=80&fit=crop&crop=center',
  group: 'https://images.unsplash.com/photo-1523050854058-8df90110c7f1?w=1200&q=80&fit=crop&crop=center',
  library: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=1200&q=80&fit=crop&crop=center',
  campus: 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=1200&q=80&fit=crop&crop=center',
  lab: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=1200&q=80&fit=crop&crop=center',
  outdoor: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80&fit=crop&crop=center',
};

// ============================================================
// DATA
// ============================================================

interface Destination {
  id: string;
  name: string;
  subject: string;
  description: string;
  image: string;
  duration: string;
  highlights: string[];
}

interface LearningOutcome {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}

interface WhyItem {
  id: string;
  number: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}

interface Step {
  number: string;
  title: string;
  description: string;
}

interface Faq {
  question: string;
  answer: string;
}

const destinations: Destination[] = [
  {
    id: 'uk-history',
    name: 'London & Oxford',
    subject: 'History & Literature',
    description: 'Walk through the streets of Shakespeare, Churchill, and the British Museum. A journey through British history, literature, and culture.',
    image: IMAGES.history,
    duration: '5–7 days',
    highlights: ['British Museum', 'Shakespeare\'s Globe', 'Oxford University', 'Tower of London'],
  },
  {
    id: 'france-science',
    name: 'Paris Science & Space',
    subject: 'Science & Technology',
    description: 'From the Cité des Sciences to the European Space Agency — a deep dive into the world of science, innovation, and exploration.',
    image: IMAGES.lab,
    duration: '4–6 days',
    highlights: ['Cité des Sciences', 'ESA Headquarters', 'Palais de la Découverte', 'Airbus Factory'],
  },
  {
    id: 'oman-nature',
    name: 'Oman Mountains & Wadis',
    subject: 'Geography & Environment',
    description: 'Explore the unique geology and ecosystems of Oman — from the Hajar Mountains to the coastal plains and ancient wadis.',
    image: IMAGES.outdoor,
    duration: '3–5 days',
    highlights: ['Hajar Mountains', 'Wadi Shab', 'Jebel Akhdar', 'Bimmah Sinkhole'],
  },
  {
    id: 'italy-art',
    name: 'Florence & Rome',
    subject: 'Art & Architecture',
    description: 'Renaissance art, Roman engineering, and the birth of modern Western culture — a journey through the greatest art cities of Italy.',
    image: IMAGES.museum,
    duration: '6–8 days',
    highlights: ['Uffizi Gallery', 'St. Peter\'s Basilica', 'Colosseum', 'Vatican Museums'],
  },
  {
    id: 'uae-innovation',
    name: 'Dubai & Abu Dhabi',
    subject: 'Business & Innovation',
    description: 'Explore the world\'s most dynamic cities — from sustainable architecture to the future of AI and space travel.',
    image: IMAGES.campus,
    duration: '4–6 days',
    highlights: ['Museum of the Future', 'Masdar City', 'Sheikh Zayed Grand Mosque', 'Dubai Innovation Hub'],
  },
  {
    id: 'switzerland-geography',
    name: 'Swiss Alps & Environment',
    subject: 'Geography & Climate',
    description: 'Study climate change, glaciology, and sustainable tourism in the heart of the Swiss Alps — a classroom in nature.',
    image: IMAGES.outdoor,
    duration: '5–7 days',
    highlights: ['Jungfraujoch', 'Aletsch Glacier', 'UNESCO Sites', 'Environmental Research Center'],
  },
];

const learningOutcomes: LearningOutcome[] = [
  {
    id: 'critical',
    title: 'Critical Thinking',
    description: 'Students learn to analyze, evaluate, and synthesize information from real-world contexts.',
    icon: <IconBrain />,
  },
  {
    id: 'cultural',
    title: 'Cultural Awareness',
    description: 'Immersion in different cultures develops empathy, adaptability, and global perspective.',
    icon: <IconGlobe />,
  },
  {
    id: 'collaboration',
    title: 'Collaboration',
    description: 'Working in groups to solve problems and complete tasks builds communication and teamwork.',
    icon: <IconUsers />,
  },
  {
    id: 'independence',
    title: 'Independence',
    description: 'Traveling away from home builds resilience, confidence, and a sense of personal responsibility.',
    icon: <IconStar />,
  },
];

const whyItems: WhyItem[] = [
  {
    id: 'curriculum',
    number: '01',
    title: 'Curriculum-Aligned',
    description: 'Every itinerary is designed to support specific learning objectives and outcomes.',
    icon: <IconBook />,
  },
  {
    id: 'safety',
    number: '02',
    title: 'Full Risk Management',
    description: 'Complete risk assessments, insurance coverage, and safety protocols in place.',
    icon: <IconShield />,
  },
  {
    id: 'support',
    number: '03',
    title: 'Teacher Support',
    description: 'We handle the logistics so teachers can focus on the learning experience.',
    icon: <IconUsers />,
  },
  {
    id: 'transparency',
    number: '04',
    title: 'Transparent Pricing',
    description: 'Clear, itemized quotes with no hidden costs — budget with confidence.',
    icon: <IconClock />,
  },
];

const steps: Step[] = [
  {
    number: '01',
    title: 'Initial Consultation',
    description: 'We meet with school staff to understand learning objectives, group size, and any specific curriculum requirements.',
  },
  {
    number: '02',
    title: 'Itinerary Design',
    description: 'A draft itinerary is created and shared for review, ensuring every stop aligns with the educational goals.',
  },
  {
    number: '03',
    title: 'Logistics & Approvals',
    description: 'We handle risk assessments, permissions, insurance, and all documentation required by the school board.',
  },
  {
    number: '04',
    title: 'Pre-Trip Briefing',
    description: 'A detailed briefing is provided to all staff and students — covering safety, culture, and what to expect.',
  },
  {
    number: '05',
    title: 'On-Ground Support',
    description: 'Dedicated support throughout the trip, with a point of contact available 24/7 for any concerns.',
  },
  {
    number: '06',
    title: 'Post-Trip Debrief',
    description: 'We review the trip with teachers and students to capture feedback and learning outcomes for future trips.',
  },
];

const faqs: Faq[] = [
  {
    question: 'What age groups do you cater to?',
    answer: 'We design educational trips for students from primary school through to university level. Each itinerary is age-appropriate and aligned with the relevant curriculum.',
  },
  {
    question: 'How far in advance should we plan?',
    answer: 'We recommend at least 6–8 months of lead time for international trips and 3–4 months for regional trips. This allows time for approvals, permissions, and securing the best logistics.',
  },
  {
    question: 'Can you accommodate special needs or dietary requirements?',
    answer: 'Absolutely. We work with you to ensure every student is supported, including dietary requirements, mobility needs, and any other accommodations.',
  },
  {
    question: 'What about safety and supervision?',
    answer: 'Safety is our priority. We provide clear supervision ratios, risk assessments, and a dedicated team on the ground. All guides are trained in safeguarding and first aid.',
  },
];

// ============================================================
// COMPONENT
// ============================================================

export default function EducationalTrips() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const statsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.3 }
    );

    const statItems = document.querySelectorAll('.stat-item');
    statItems.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');

        :root {
          --teal: #294b5a;
          --teal-d: #1a3140;
          --teal-l: #3b6272;
          --gold: #d3be76;
          --gold-l: #ede4b5;
          --gold-d: #b09a50;
          --cream: #f7f4ee;
          --mist: #edeae2;
          --silver: #8a9aa3;
          --ink: #1a2f38;
          --radius: 10px;
          --shadow-sm: 0 6px 20px rgba(26, 49, 61, .07);
          --shadow-md: 0 20px 48px rgba(26, 49, 61, .12);
          --shadow-lg: 0 28px 64px rgba(26, 49, 61, .18);
        }

        * { box-sizing: border-box; }
        .visa-page { font-family: 'DM Sans', sans-serif; background: var(--cream); -webkit-font-smoothing: antialiased; }
        .visa-page h1, .visa-page h2, .visa-page h3 { font-family: 'Playfair Display', serif; }

        .eyebrow { display: inline-flex; align-items: center; gap: 10px; font-size: 11px; font-weight: 600; letter-spacing: 1.5px; text-transform: uppercase; color: var(--gold-d); }
        .eyebrow::before { content: ''; width: 22px; height: 2px; background: var(--gold); border-radius: 2px; }
        .eyebrow.light { color: var(--gold-l); }
        .eyebrow.light::before { background: var(--gold-l); opacity: .6; }
        .eyebrow.centered { justify-content: center; }

        .section-title { font-size: clamp(1.7rem, 2.6vw, 2.4rem); font-weight: 500; color: var(--ink); line-height: 1.2; margin: 10px 0 12px; }
        .section-title.centered { text-align: center; }
        .section-sub { font-size: 15px; color: var(--silver); font-weight: 300; line-height: 1.7; max-width: 520px; }
        .section-sub.centered { margin: 0 auto; text-align: center; }
        .section-pad { padding: 84px 0; }
        @media (max-width: 991px) { .section-pad { padding: 64px 0; } }
        @media (max-width: 576px) { .section-pad { padding: 48px 0; } }
        .bg-cream { background: var(--cream); }
        .bg-white { background: #fff; }
        .bg-teal { background: var(--teal-d); }

        .vbtn-primary { display: inline-flex; align-items: center; gap: 8px; background: var(--gold); color: var(--teal-d); border-radius: 5px; font-size: 12.5px; font-weight: 700; letter-spacing: .3px; padding: 14px 26px; text-decoration: none; transition: transform .2s, background .2s; box-shadow: 0 10px 28px rgba(211,190,118,.28); border: none; cursor: pointer; }
        .vbtn-primary:hover { background: #e2ce86; transform: translateY(-2px); }
        .vbtn-ghost { display: inline-flex; align-items: center; background: rgba(255,255,255,.1); backdrop-filter: blur(4px); color: #fff; border: 1px solid rgba(255,255,255,.25); border-radius: 5px; font-size: 12.5px; font-weight: 600; letter-spacing: .3px; padding: 14px 24px; text-decoration: none; transition: background .2s, border-color .2s; }
        .vbtn-ghost:hover { border-color: #fff; background: rgba(255,255,255,.18); }

        /* HERO */
        .svc-hero { position: relative; min-height: 500px; display: flex; align-items: center; overflow: hidden; background: var(--teal-d); }
        .svc-hero-img { position: absolute; inset: 0; background-size: cover; background-position: center; opacity: 0.28; }
        .svc-hero-veil { position: absolute; inset: 0; background: linear-gradient(180deg, rgba(26,49,61,.55) 0%, rgba(26,49,61,.92) 100%); }
        .svc-hero-inner { position: relative; z-index: 2; padding: 64px 0 40px; }
        .svc-hero-title { font-weight: 600; color: #fff; line-height: 1.16; font-size: clamp(30px, 4vw, 48px); max-width: 660px; margin-bottom: 16px; }
        .svc-hero-title .gold { font-style: italic; color: var(--gold); font-weight: 400; }
        .svc-hero-sub { font-size: 15px; color: rgba(255,255,255,.78); font-weight: 300; line-height: 1.75; max-width: 540px; margin-bottom: 30px; }
        .svc-hero-ctas { display: flex; gap: 12px; flex-wrap: wrap; }
        .svc-breadcrumb { font-size: 11.5px; color: rgba(255,255,255,.5); margin-bottom: 18px; }
        .svc-breadcrumb a { color: rgba(255,255,255,.7); text-decoration: none; }
        .svc-breadcrumb a:hover { color: var(--gold-l); }

        /* STATS */
        .stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 30px; }
        @media (max-width: 768px) { .stats-grid { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 480px) { .stats-grid { grid-template-columns: 1fr; } }
        .stat-item {
          text-align: center;
          padding: 20px;
          opacity: 0;
          transform: translateY(20px);
          transition: opacity .8s ease, transform .8s ease;
        }
        .stat-item.visible { opacity: 1; transform: translateY(0); }
        .stat-item .value { font-family: 'Playfair Display', serif; font-size: 2.6rem; font-weight: 600; color: var(--gold); line-height: 1.1; }
        .stat-item .label { font-size: 13px; color: rgba(255,255,255,.7); font-weight: 300; margin-top: 4px; }

        /* DESTINATIONS */
        .dest-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 28px; }
        @media (max-width: 992px) { .dest-grid { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 640px) { .dest-grid { grid-template-columns: 1fr; } }

        .dest-card {
          background: #fff;
          border-radius: var(--radius);
          overflow: hidden;
          box-shadow: var(--shadow-sm);
          border: 1px solid rgba(41,75,90,.06);
          transition: transform .4s cubic-bezier(.22,1,.36,1), box-shadow .4s cubic-bezier(.22,1,.36,1);
        }
        .dest-card:hover { transform: translateY(-6px); box-shadow: var(--shadow-md); }
        .dest-card-img { height: 200px; background-size: cover; background-position: center; }
        .dest-card-body { padding: 22px 24px 26px; }
        .dest-card-body .subject { font-size: 10px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; color: var(--gold-d); margin-bottom: 4px; display: block; }
        .dest-card-body h3 { font-size: 1.15rem; font-weight: 600; color: var(--ink); margin-bottom: 4px; }
        .dest-card-body .duration { font-size: 12px; color: var(--silver); font-weight: 400; margin-bottom: 8px; display: block; }
        .dest-card-body p { font-size: 13px; color: var(--silver); font-weight: 300; line-height: 1.6; margin-bottom: 12px; }
        .dest-highlights { display: flex; flex-wrap: wrap; gap: 4px 10px; }
        .dest-highlights span { font-size: 11.5px; color: var(--teal); font-weight: 400; }
        .dest-highlights span::before { content: '—'; margin-right: 6px; color: var(--gold); }

        /* LEARNING OUTCOMES */
        .outcome-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 28px; }
        @media (max-width: 900px) { .outcome-grid { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 560px) { .outcome-grid { grid-template-columns: 1fr; } }
        .outcome-item {
          background: #fff;
          border-radius: var(--radius);
          padding: 32px 26px;
          text-align: center;
          border: 1px solid rgba(41,75,90,.06);
          transition: border-color .3s ease, box-shadow .3s ease, transform .3s ease;
        }
        .outcome-item:hover { border-color: rgba(211,190,118,.5); box-shadow: var(--shadow-sm); transform: translateY(-3px); }
        .outcome-item .icon-wrap { display: flex; align-items: center; justify-content: center; margin-bottom: 14px; color: var(--gold-d); }
        .outcome-item h3 { font-size: 14px; font-weight: 600; color: var(--ink); margin-bottom: 6px; }
        .outcome-item p { font-size: 12.5px; color: var(--silver); font-weight: 300; line-height: 1.7; margin: 0; }

        /* WHY CHOOSE US */
        .why-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 28px; }
        @media (max-width: 900px) { .why-grid { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 560px) { .why-grid { grid-template-columns: 1fr; } }
        .why-item {
          background: #fff;
          border-radius: var(--radius);
          padding: 28px 24px;
          border: 1px solid rgba(41,75,90,.06);
          transition: border-color .3s ease, box-shadow .3s ease, transform .3s ease;
          text-align: center;
        }
        .why-item:hover { border-color: rgba(211,190,118,.5); box-shadow: var(--shadow-sm); transform: translateY(-3px); }
        .why-item .num { font-family: 'Playfair Display', serif; font-size: 1.8rem; font-weight: 600; color: var(--gold); opacity: .4; display: block; margin-bottom: 4px; }
        .why-item .icon-wrap { display: flex; align-items: center; justify-content: center; margin-bottom: 12px; color: var(--gold-d); }
        .why-item h3 { font-size: 14px; font-weight: 600; color: var(--ink); margin-bottom: 4px; }
        .why-item p { font-size: 12.5px; color: var(--silver); font-weight: 300; line-height: 1.7; margin: 0; }

        /* PROCESS */
        .process-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 28px; }
        @media (max-width: 900px) { .process-grid { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 560px) { .process-grid { grid-template-columns: 1fr; } }
        .process-step {
          background: #fff;
          border-radius: var(--radius);
          padding: 28px 24px;
          border: 1px solid rgba(41,75,90,.06);
          transition: border-color .3s ease, box-shadow .3s ease, transform .3s ease;
        }
        .process-step:hover { border-color: rgba(211,190,118,.5); box-shadow: var(--shadow-sm); transform: translateY(-3px); }
        .process-step .num { font-family: 'Playfair Display', serif; font-size: 2rem; font-weight: 600; color: var(--gold); opacity: .3; margin-bottom: 8px; display: block; }
        .process-step h3 { font-size: 15px; font-weight: 600; color: var(--ink); margin-bottom: 4px; }
        .process-step p { font-size: 13px; color: var(--silver); font-weight: 300; line-height: 1.7; margin: 0; }

        /* FAQ */
        .faq-list { max-width: 760px; margin: 0 auto; }
        .faq-item { border-bottom: 1px solid rgba(41,75,90,.1); }
        .faq-item:first-child { border-top: 1px solid rgba(41,75,90,.1); }
        .faq-q {
          width: 100%; background: none; border: none; text-align: left; cursor: pointer;
          display: flex; align-items: center; justify-content: space-between; gap: 20px;
          padding: 20px 4px; font-family: 'DM Sans', sans-serif; font-size: 14px;
          font-weight: 500; color: var(--ink);
        }
        .faq-q .plus { flex: none; width: 22px; height: 22px; border-radius: 50%; border: 1.5px solid var(--gold-d); position: relative; transition: transform .3s ease, background .3s ease; }
        .faq-q .plus::before, .faq-q .plus::after { content: ''; position: absolute; background: var(--gold-d); top: 50%; left: 50%; transform: translate(-50%,-50%); }
        .faq-q .plus::before { width: 9px; height: 1.4px; }
        .faq-q .plus::after { width: 1.4px; height: 9px; transition: opacity .2s ease; }
        .faq-item.open .plus { background: var(--gold-d); transform: rotate(180deg); }
        .faq-item.open .plus::before, .faq-item.open .plus::after { background: #fff; }
        .faq-item.open .plus::after { opacity: 0; }
        .faq-a { max-height: 0; overflow: hidden; transition: max-height .35s ease; }
        .faq-item.open .faq-a { max-height: 240px; }
        .faq-a p { font-size: 13.5px; color: var(--silver); font-weight: 300; line-height: 1.75; padding: 0 4px 24px; max-width: 640px; }

        /* CTA BANNER */
        .cta-banner { background: var(--teal); border-radius: var(--radius); padding: 44px 40px; display: flex; align-items: center; justify-content: space-between; gap: 30px; flex-wrap: wrap; }
        .cta-banner-title { color: #fff; font-size: 1.3rem; font-weight: 500; margin-bottom: 4px; }
        .cta-banner-sub { color: rgba(255,255,255,.7); font-size: 13px; font-weight: 300; max-width: 460px; }

        @media (max-width: 576px) {
          .cta-banner { padding: 28px 20px; }
          .dest-card-body { padding: 18px 18px 22px; }
          .process-step { padding: 22px 18px; }
        }
      `}</style>

      <div className="visa-page">
        <Header />

        {/* ===== HERO ===== */}
        <section className="svc-hero">
          <div className="svc-hero-img" style={{ backgroundImage: `url(${IMAGES.hero})` }} />
          <div className="svc-hero-veil" />
          <div className="container svc-hero-inner">
            <div className="svc-breadcrumb">
              <a href="/services">Services</a> / Educational Trips
            </div>
            <div className="eyebrow light" style={{ marginBottom: 14 }}>
              Learning Beyond the Classroom
            </div>
            <h1 className="svc-hero-title">
              Educational Trips <span className="gold">That Inspire</span>
            </h1>
            <p className="svc-hero-sub">
              Curriculum-aligned itineraries, proper supervision ratios, and full risk assessments —
              so the only thing your school has to manage is the learning itself.
            </p>
            <div className="svc-hero-ctas">
              <a href="#destinations" className="vbtn-primary">Explore Destinations</a>
              <a href="/contact" className="vbtn-ghost">Get a Quote</a>
            </div>
          </div>
        </section>

        <DuneRule />

        {/* ===== INTRO ===== */}
        <section className="section-pad bg-white">
          <div className="container" style={{ maxWidth: 720, margin: '0 auto', textAlign: 'center' }}>
            <span className="eyebrow centered">Why Educational Travel Matters</span>
            <h2 className="section-title centered">Where Learning Comes Alive</h2>
            <p className="section-sub centered">
              An educational trip transforms the classroom into the real world. Students don't just
              read about history — they walk through it. They don't just study geography — they
              experience it. We design trips that align with your curriculum while giving students
              the experience of a lifetime.
            </p>
          </div>
        </section>

        <DuneRule />

        {/* ===== STATS ===== */}
        <section className="section-pad bg-teal">
          <div className="container">
            <div className="stats-grid" ref={statsRef}>
              {[
                { value: '15+', label: 'Years of Experience' },
                { value: '200+', label: 'School Trips Organized' },
                { value: '12', label: 'Countries Visited' },
                { value: '98%', label: 'Teacher Satisfaction' },
              ].map((s, idx) => (
                <div className="stat-item" key={idx} style={{ transitionDelay: `${idx * 120}ms` }}>
                  <div className="value">{s.value}</div>
                  <div className="label">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <DuneRule />

        {/* ===== DESTINATIONS ===== */}
        <section className="section-pad bg-cream" id="destinations">
          <div className="container">
            <div style={{ marginBottom: 44 }}>
              <span className="eyebrow centered" style={{ justifyContent: 'center' }}>
                Our Destinations
              </span>
              <h2 className="section-title centered">Where Will Your Students Go?</h2>
              <p className="section-sub centered">
                From European history to Middle Eastern innovation — we design trips that connect
                directly to your curriculum.
              </p>
            </div>
            <div className="dest-grid">
              {destinations.map((dest) => (
                <div className="dest-card" key={dest.id}>
                  <div className="dest-card-img" style={{ backgroundImage: `url(${dest.image})` }} />
                  <div className="dest-card-body">
                    <span className="subject">{dest.subject}</span>
                    <h3>{dest.name}</h3>
                    <span className="duration">📅 {dest.duration}</span>
                    <p>{dest.description}</p>
                    <div className="dest-highlights">
                      {dest.highlights.map((h, idx) => (
                        <span key={idx}>{h}</span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <DuneRule />

        {/* ===== LEARNING OUTCOMES ===== */}
        <section className="section-pad bg-white">
          <div className="container">
            <div style={{ marginBottom: 44 }}>
              <span className="eyebrow centered" style={{ justifyContent: 'center' }}>
                Skills Developed
              </span>
              <h2 className="section-title centered">What Students Gain</h2>
            </div>
            <div className="outcome-grid">
              {learningOutcomes.map((outcome) => (
                <div className="outcome-item" key={outcome.id}>
                  <div className="icon-wrap">{outcome.icon}</div>
                  <h3>{outcome.title}</h3>
                  <p>{outcome.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <DuneRule />

        {/* ===== WHY CHOOSE US ===== */}
        <section className="section-pad bg-cream">
          <div className="container">
            <div style={{ marginBottom: 44 }}>
              <span className="eyebrow centered" style={{ justifyContent: 'center' }}>
                Why Schools Choose Us
              </span>
              <h2 className="section-title centered">Built for Educators, by Travel Experts</h2>
            </div>
            <div className="why-grid">
              {whyItems.map((item) => (
                <div className="why-item" key={item.id}>
                  <span className="num">{item.number}</span>
                  <div className="icon-wrap">{item.icon}</div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <DuneRule />

        {/* ===== PROCESS ===== */}
        <section className="section-pad bg-white">
          <div className="container">
            <div style={{ marginBottom: 44 }}>
              <span className="eyebrow centered" style={{ justifyContent: 'center' }}>
                How It Works
              </span>
              <h2 className="section-title centered">From First Call to Departure</h2>
            </div>
            <div className="process-grid">
              {steps.map((step) => (
                <div className="process-step" key={step.number}>
                  <span className="num">{step.number}</span>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <DuneRule />

        {/* ===== FAQ ===== */}
        <section className="section-pad bg-cream">
          <div className="container">
            <div style={{ marginBottom: 36 }}>
              <span className="eyebrow centered" style={{ justifyContent: 'center' }}>
                Common Questions
              </span>
              <h2 className="section-title centered">Everything You Need to Know</h2>
            </div>
            <div className="faq-list">
              {faqs.map((f, idx) => {
                const isOpen = openFaq === idx;
                return (
                  <div className={`faq-item${isOpen ? ' open' : ''}`} key={f.question}>
                    <button
                      type="button"
                      className="faq-q"
                      onClick={() => setOpenFaq(isOpen ? null : idx)}
                      aria-expanded={isOpen}
                    >
                      <span>{f.question}</span>
                      <span className="plus" />
                    </button>
                    <div className="faq-a">
                      <p>{f.answer}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <DuneRule />

        {/* ===== CTA FINAL ===== */}
        <section className="section-pad bg-white" style={{ paddingTop: 0 }}>
          <div className="container">
            <div className="cta-banner">
              <div>
                <div className="cta-banner-title">Plan Your School's Next Adventure</div>
                <div className="cta-banner-sub">
                  Tell us the year group, subject focus, and rough dates — we'll draft an itinerary
                  your board can review.
                </div>
              </div>
              <a href="/contact" className="vbtn-primary">
                Get a Quote
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </a>
            </div>
          </div>
        </section>

        <DefaultFooter />
      </div>
    </>
  );
}